import type { ReactNode } from "react";

/**
 * Cabecera de cada vista del login: ícono opcional, título (el único h1 de la página) y una línea de apoyo.
 * Sin etiqueta en mayúsculas encima: el logo de la cabecera ya dice dónde está.
 */
export function ViewHeader({ title, subtitle, icon }: { title: string; subtitle?: string; icon?: ReactNode }) {
  return (
    <div className="mb-8 flex flex-col items-center gap-2 text-center">
      {icon && <div className="mb-2">{icon}</div>}
      <h1 className="text-balance text-[28px] font-semibold leading-[1.15] text-foreground">{title}</h1>
      {subtitle && <p className="text-balance text-[15px] leading-[1.45] text-muted-foreground">{subtitle}</p>}
    </div>
  );
}

/** Ícono en baldosa redonda de 48 px. Neutra por defecto; tintada solo cuando el estado lo pide. */
export function ViewIcon({ children, tone = "neutral" }: { children: ReactNode; tone?: "neutral" | "success" | "error" }) {
  const toneClass = {
    neutral: "bg-black/[0.05] text-muted-foreground dark:bg-white/[0.08]",
    success: "bg-success/12 text-success",
    error: "bg-destructive/10 text-destructive",
  }[tone];
  return (
    <span aria-hidden="true" className={`flex h-12 w-12 items-center justify-center rounded-full ${toneClass}`}>
      {children}
    </span>
  );
}
